"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendMessageBackToPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _sendMessageBack = require("../actions/sendMessageBack");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(postActivityWithMessageBack),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(sendMessageBackToPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(sendMessageBackToPostActivitySaga);

function postActivityWithMessageBack(_ref) {
  var _ref$payload, displayText, text, value;

  return _regenerator["default"].wrap(function postActivityWithMessageBack$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref$payload = _ref.payload, displayText = _ref$payload.displayText, text = _ref$payload.text, value = _ref$payload.value;

          if (!(text || value)) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return (0, _effects.put)((0, _postActivity["default"])({
            channelData: {
              messageBack: {
                displayText: displayText
              }
            },
            text: text,
            type: 'message',
            value: value
          }));

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendMessageBackToPostActivity() {
  return _regenerator["default"].wrap(function sendMessageBackToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_sendMessageBack.SEND_MESSAGE_BACK, postActivityWithMessageBack);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function sendMessageBackToPostActivitySaga() {
  return _regenerator["default"].wrap(function sendMessageBackToPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(sendMessageBackToPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}